<template>
	<div class="cli-loader">
		<slot>
			{{text}}
		</slot>
		<span ref="txt" class="cli-loader__slash"></span>
	</div>
</template>
<script>
const SYMBOLS = ['/', '-', '\\', '|', '-'];
// const SYMBOLS = "◡◡ ⊙⊙ ◠◠";
// const SYMBOLS = "⢄⢂⢁⡁⡈⡐⡠";
// const SYMBOLS = "⢹⢺⢼⣸⣇⡧⡗⡏";

export default {
	name: 'CliLoader',
	props: {
		text: { type: String, default: 'loading.. '}
	},

	static: () => ({
		cur: 0,
	}),

	mounted () {
		const i = setInterval(() => {
			if (!this.$refs.txt)
				return clearInterval(this.i);
			this.$refs.txt.textContent = SYMBOLS[this.cur++ % SYMBOLS.length];
		}, 100);
	},
};

</script>

<style>

.cli-loader {
	/*font: 300 18px Montserrat;*/

	&__slash {
		display: inline-block;
		min-width: 1em;
	}

	&.fetch--pending {
	    margin-bottom: var(--page-pad);
	}
}

button .cli-loader {
	display: inline-block;
}

/*.l-main > .fetch > .cli-loader {
  position: absolute;
  right: 66px;
  right: 0;
  top: -31px;
}*/

</style>